// extracted by mini-css-extract-plugin
export default {"container":"style_container__+8iDV","card":"style_card__1XKPy"};